import { Icon, LoadingSpinner, toast } from 'legacy-packages/ft-cb';
import React, { useState, useRef } from 'react';
import { UploadAnswerSheetsToast } from 'legacy-src/components/paperscorer';
import A11y from 'chameleon/ui-stack/utilities/a11y';
import axios from 'axios';
import log from 'chameleon/ui-stack/utilities/log';

function UploadAnswerSheet() {
  const uploadRef = useRef();
  const [uploadLoading, setUploadLoading] = useState(false);

  const uploadFiles = (event) => {
    const { files } = event.target;
    const formData = new FormData();

    Array.from(files).map((file) => formData.append('files', file));
    setUploadLoading(true);
    axios
      .post(
        `${FYM_BACKEND_PAPERSCORER_API_URL}/submit_answer_sheet`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        },
      )
      .then((response) => {
        const { successfull, failed } = response.data;

        if (failed.length === 0 && successfull !== null) {
          UploadAnswerSheetsToast();
        } else if (failed.length > 0) {
          toast.error(`${failed.length} answer sheet(s) uploads failed.`);
        } else {
          toast.error("Couldn't upload file(s), please contact support");
        }
      })
      .catch((error) => {
        log(error);
      })
      .finally(() => {
        setUploadLoading(false);
      });
  };
  return (
    <A11y>
      <div
        className="text-blue-700 flex items-center content-center cursor-pointer"
        role="button"
        tabIndex="0"
        onClick={() => uploadRef.current.click()}
      >
        <input
          type="file"
          multiple
          accept=".pdf, .jpg, .png, .jpeg"
          hidden
          ref={uploadRef}
          onChange={uploadFiles}
        />
        <Icon
          name="upload"
          size="15px"
          title="Upload Answer Sheets"
          ariaLabel="Upload Answer Sheets"
        />
        <span className="item-text">Upload Answer Sheets</span>
        {uploadLoading && <LoadingSpinner />}
      </div>
    </A11y>
  );
}

export default UploadAnswerSheet;
